import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Empty, Button, Icon, Row } from "@perxis-auto/ui-kit";
import "../../../entities/vehicle/api/api.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../../features/benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "@perxis-auto/shared";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import { selectIsVehiclesDataMissing } from "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import { selectVehiclesCount } from "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import { selectVehiclesTotalPages } from "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import "react-router";
import { selectSlice } from "../../../shared/store/pagination/model/selectors/selectSlice.js";
import { actions } from "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import { actions as actions$1 } from "../../../features/filterChoice/model/slice.js";
import { useConstructorContext } from "../../../shared/context/constructor.js";
import "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { Page } from "../ui/page/Page.js";
const useContainer = (item) => {
  const { redirects, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { layout, widgets } = useConstructorContext();
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const { offset, limit } = useAppSelector(selectSlice);
  const totalPages = useAppSelector(selectVehiclesTotalPages);
  const count = useAppSelector(selectVehiclesCount);
  const isVehiclesDataMissing = useAppSelector(selectIsVehiclesDataMissing);
  const pageNum = Math.ceil(offset / limit);
  const isMorePages = pageNum < totalPages - 1;
  const isEmpty = count === 0;
  const onShowMore = useCallback(() => {
    dispatch(actions.setOffset(offset + limit));
  }, [dispatch, limit, offset]);
  const onReset = useCallback(() => {
    dispatch(actions$1.resetValues());
  }, [dispatch]);
  const onLoadedVehicles = useCallback(() => {
  }, []);
  const renderPages = useCallback(() => {
    if (isVehiclesDataMissing) {
      return /* @__PURE__ */ jsx(
        Empty,
        {
          title: t("widgets.vehiclesCatalog.missingData.title"),
          description: /* @__PURE__ */ jsx(Fragment, { children: t("widgets.vehiclesCatalog.missingData.tryAgainLater") })
        }
      );
    }
    if (isEmpty) {
      return /* @__PURE__ */ jsx(
        Empty,
        {
          title: t("widgets.vehiclesCatalog.empty.title"),
          description: /* @__PURE__ */ jsxs(Fragment, { children: [
            t("widgets.vehiclesCatalog.empty.notFound"),
            /* @__PURE__ */ jsx("br", {}),
            t("widgets.vehiclesCatalog.empty.tryToChange")
          ] }),
          children: /* @__PURE__ */ jsx(Button, { type: "ghost", icon: /* @__PURE__ */ jsx(Icon, { name: "cross", sticker: "vehicle-list-reset-icon" }), onClick: onReset, children: t("widgets.vehiclesCatalog.empty.reset") })
        }
      );
    }
    const pages = [];
    for (let i = 0; i <= pageNum; i++) {
      pages.push(
        /* @__PURE__ */ jsx(
          Page,
          {
            page: i,
            redirect: redirects.link,
            onLoadedVehicles,
            layout,
            widgets
          },
          i
        )
      );
    }
    return /* @__PURE__ */ jsx(Row, { gutter: [18, "vertical-sky"], children: pages.map((page) => page) });
  }, [isEmpty, isVehiclesDataMissing, layout, onLoadedVehicles, onReset, pageNum, redirects.link, t, widgets]);
  return {
    ...props,
    layout,
    widgets,
    isMorePages,
    onShowMore,
    renderPages,
    t
  };
};
export {
  useContainer
};
